var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"window-size-to-store",rawName:"v-window-size-to-store"}],staticClass:"app",class:{
		'app_show-header': _vm.isHeaderShowing,
	},attrs:{"id":"app"}},[(_vm.isLoggedIn && !_vm.$route.meta.hideNavbar && _vm.agency)?_c('MainMenu',{staticClass:"app__header-panel"}):_vm._e(),(_vm.accessGranted)?_c('router-view'):(_vm.errorMessage)?_c('error-500'):_vm._e(),_c('nice-icon-symbols'),(_vm.showHelpModal)?_c('HelpModal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }